import ReactGA from "react-ga4";
import { getSdk } from "./sdkService";
import { config } from "../config/config";
import { getAppState } from "../state";
import packageJson from "../../package.json";
import { getCurrentProfile } from "./multipleProfilesService";
import { getAddonsListWithBase } from "./layoutService";

async function currentProfile() {
  let profileId = "";
  const currentProfile = await getCurrentProfile();
  if (currentProfile) {
    profileId = currentProfile?.profileId;
  }
  return profileId;
}

function getSeriesPercentageWatched(episodesList) {}

export async function sendSearchEventDataForBytePlus({ searchTerm, userData, currentScreen, previousScreen }) {
  if (!userData) {
    const sdk = await getSdk();
    userData = await sdk.userManager.get();
  }
  var dt = {
    current_screen: currentScreen || sessionStorage.getItem("currentScreen") || null,
    previous_screen: previousScreen || sessionStorage.getItem("prevScreen") || null,
    search_term: searchTerm,
    language: localStorage.getItem("locale"),
    platform: "vidaa" || config.get().sdk.platFormName,
    os_type: config.get().sdk.clientType,
    device_type: config.get().sdk.deviceType,
    date_time: new Date().toISOString().substring(0, 19) + "Z",
    location_country: getAppState()?.country?.toUpperCase(),
    // logged_in: getAppState().userLogged || userData?.logged_in ? "yes" : "no",
    profile_type: getAppState()?.currentProfileType || userData?.profileType,
    user_type: userData?.settings?.accountStatus || "Visitor",
    starz_uid: userData?.globalUserId || userData?.user?.globalUserId || null,
    guid: userData?.globalUserId || userData?.user?.globalUserId || null,
    os_version: await extractOSVersion(),
    device_model: await getDeviceInfo(),
    // hash_uid: null,
    entitlements: getAddonsListWithBase(),
    mop_detail: null,
    a_profile_id: (await currentProfile()) || ""
  };
  // console.log("search_run", dt)
  trackByteEvent("search_run", dt);
  // call DLS
  // dt.guid = userData?.globalUserId || userData?.user?.globalUserId || null
  dt.page_type = "search";
  triggerDLSEvent(await formatDLSData("search_run", dt));
}

export async function sendCarouselClickEventDataForBytePlus({
  carouselId,
  carouselTitle,
  carouselData,
  mediaData,
  userData,
  currentScreen,
  previousScreen,
  titleOrderId,
  carouselOrderId
}) {
  if (!userData) {
    const sdk = await getSdk();
    userData = await sdk.userManager.get();
  }
  var dt = {
    current_screen: currentScreen || sessionStorage.getItem("currentScreen") || null,
    previous_screen: previousScreen || sessionStorage.getItem("prevScreen") || null,
    language: localStorage.getItem("locale"),
    // logged_in: getAppState().userLogged || userData?.logged_in ? "yes" : "no",
    date_time: new Date().toISOString().substring(0, 19) + "Z",
    user_type: userData?.settings?.accountStatus || "Visitor",
    user_status: getAppState().userLogged || userData?.logged_in ? "login" : "log out",
    os_type: config.get().sdk.clientType,
    device_type: config.get().sdk.deviceType,
    location_country: getAppState()?.country?.toUpperCase(),
    profile_type: getAppState()?.currentProfileType || userData?.profileType,
    starz_uid: userData?.globalUserId || userData?.user?.globalUserId || null,
    os_version: await extractOSVersion(),
    device_model: await getDeviceInfo(),
    // hash_uid: null,
    guid: userData?.globalUserId || userData?.user?.globalUserId || null,
    entitlements: getAddonsListWithBase(),
    mop_detail: null,
    program_category:
      mediaData?.assetTypesPriority ||
      (mediaData?.assetTypes && mediaData?.assetTypes[0]) ||
      mediaData?.contentType ||
      null,
    platform: "vidaa" || config.get().sdk.platFormName,
    content_type: getContentTypeForAnalytics(mediaData),
    title_id: mediaData?.id || null,
    series_id: mediaData?.seriesId || mediaData?.id || null,
    title_name: mediaData?.title || null,
    title_order_id:
      titleOrderId == 0
        ? 0
        : titleOrderId ||
          mediaData?.itemIndex ||
          mediaData?.episodesList?.filter(title => title.id == mediaData.id)[0]?.itemIndex,
    carousel_id: carouselId || carouselData?.id || null,
    carousel_name: carouselTitle || carouselData?.title || null,
    carousel_order_id:
      carouselOrderId == 0
        ? 0
        : carouselOrderId || carouselData?.layoutOrder || sessionStorage.getItem("refCarouselOrderId") || null,
    rec_variant: carouselData?.contentRules?.type || sessionStorage.getItem("refCarouselRecVariant") || null,
    a_profile_id: (await currentProfile()) || "",
    asset_ownership: mediaData.contentOwnership || null
  };
  // if (dt.content_type!="series"){
  //     // if content_type is episode, pass it as series
  //     if(dt.content_type=="episode"){
  //         dt.content_type = "series"
  //     } else if (window.location.pathname.includes("/series")) {
  // if (dt.content_type != "series" && dt.content_type != "episode") {
  //   if (window.location.pathname.includes("/series")) {
  //     // if we are not able to extract content type from params(eg: in explore page), we can extract from url
  //     dt.content_type = "series";
  //   }
  // }
  // if (carouselData) {
  //   if (carouselData.type == "cw") {
  //     if ((dt.content_type = "episode")) {
  //       dt.content_type = "series";
  //     }
  //   }
  // }
  //pass season and episode number if they are present(eg CW carousel)
  if (mediaData?.tvSeasonNumber && mediaData?.tvSeasonEpisodeNumber) {
    dt.current_season = mediaData?.tvSeasonNumber;
    dt.episode_number = mediaData?.tvSeasonEpisodeNumber;
  }
  if (dt.carousel_id) {
    sessionStorage.setItem("refCarId", dt.carousel_id);
  }
  if (dt.carousel_name) {
    sessionStorage.setItem("refCarouselName", dt.carousel_name);
  }
  if (dt.rec_variant && dt.rec_variant != "null") {
    sessionStorage.setItem("refCarouselRecVariant", dt.rec_variant);
  }
  if (dt.carousel_order_id || dt.carousel_order_id == 0) {
    sessionStorage.setItem("refCarouselOrderId", dt.carousel_order_id);
  }
  sessionStorage.setItem("refTitleOrderId", dt.title_order_id);
  // console.log("carousel_click", dt)
  trackByteEvent("carousel_click", dt);
  // call DLS
  dt.event_name = "carousel_click";
  dt.parent_slug = mediaData?.addonContent || null;
  triggerDLSEvent(await formatDLSData("carousel_click", dt));
}

export async function sendVideoPlayClickEventDataForBytePlus({
  thisInstance,
  carouselData,
  mediaData,
  userData,
  currentScreen,
  previousScreen,
  titleOrderId,
  carouselOrderId
}) {
  if (!userData) {
    const sdk = await getSdk();
    userData = await sdk.userManager.get();
  }
  var dt = {
    current_screen: currentScreen || sessionStorage.getItem("currentScreen") || null,
    previous_screen: previousScreen || sessionStorage.getItem("prevScreen") || null,
    referring_carousel_name: carouselData?.title || sessionStorage.getItem("refCarouselName") || null,
    referring_carousel_id: carouselData?.id || sessionStorage.getItem("refCarId") || null,
    carousel_order_id:
      carouselOrderId == 0 ? 0 : carouselOrderId || sessionStorage.getItem("refCarouselOrderId") || null,
    title_id: mediaData?.id || null,
    title_name: mediaData?.title || null,
    // "title_order_id": titleOrderId==0 ? 0 : titleOrderId || mediaData?.itemIndex || mediaData?.episodesList?.filter(title => title.id == mediaData.id)[0]?.itemIndex,
    title_order_id: sessionStorage.getItem("refTitleOrderId"),
    rec_variant: carouselData?.contentRules?.type || sessionStorage.getItem("refCarouselRecVariant") || null,
    genre: mediaData?.genre || thisInstance?.state?.titleData?.genres?.join(","),
    country_of_origin: mediaData?.countryOfOrigin || thisInstance?.state?.titleData?.countryOfOrigin,
    director_creator: thisInstance?.state?.titleData?.director?.join(","),
    cast: thisInstance?.state?.titleData?.cast?.join(","),
    age_rating: mediaData?.ageRating || thisInstance?.state?.titleData?.ageRating,
    series: thisInstance?.isSeries
      ? "yes"
      : mediaData
      ? mediaData?.programType?.toLowerCase() == "series" || mediaData?.programType?.toLowerCase() == "episode"
        ? "yes"
        : "no"
      : null,
    series_id: mediaData?.series_id || sessionStorage.getItem("currentlyPlayingid") || mediaData?.seriesId,
    current_season: mediaData?.tvSeasonNumber,
    series_percentage_watched: getSeriesPercentageWatched(thisInstance?.episodesList),
    year_of_production: mediaData?.year,
    episode_number: mediaData?.tvSeasonEpisodeNumber,
    episode_name: mediaData?.title,
    device_model: await getDeviceInfo(),
    // hash_uid: null,
    parent_slug: mediaData?.addonContent,
    signup_type: userData?.signupType,
    guid: userData?.globalUserId || userData?.user?.globalUserId || null,
    entitlements: getAddonsListWithBase(),
    mop_detail: null,
    language: localStorage.getItem("locale"),
    // logged_in: getAppState().userLogged || userData?.logged_in ? "yes" : "no",
    date_time: new Date().toISOString().substring(0, 19) + "Z",
    user_type: userData?.settings?.accountStatus || "Visitor",
    user_status: getAppState().userLogged || userData?.logged_in ? "login" : "log out",
    os_type: config.get().sdk.clientType,
    device_type: config.get().sdk.deviceType,
    location_country: getAppState()?.country?.toUpperCase(),
    profile_type: getAppState()?.currentProfileType || userData?.profileType,
    starz_uid: userData?.globalUserId || userData?.user?.globalUserId || null,
    os_version: await extractOSVersion(),
    platform: "vidaa" || config.get().sdk.platFormName,
    program_category:
      mediaData?.assetTypesPriority ||
      (mediaData?.assetTypes && mediaData?.assetTypes[0]) ||
      mediaData?.contentType ||
      null,
    a_profile_id: (await currentProfile()) || "",
    asset_ownership: mediaData.contentOwnership || null,
    content_type: mediaData?.contentTypeYoubora || mediaData.contentType || mediaData.programType
  };
  // store series/movie id till stay event, where it will be cleared
  sessionStorage.setItem("currentlyPlayingid", dt?.series_id);
  sessionStorage.setItem("currentlyPlayingisSeries", dt?.series);
  if (dt.series_id == "undefined" || dt.series_id == "null" || dt.series_id == undefined || dt.series_id == null) {
    dt.series_id = mediaData?.seriesId || dt.title_id;
  }
  if (dt.referring_carousel_id == null) {
    dt.carousel_order_id = null;
  }
  if (
    dt.title_order_id == null ||
    dt.title_order_id == undefined ||
    dt.title_order_id == "undefined" ||
    dt.title_order_id == "null"
  ) {
    dt.title_order_id = null;
  }
  // console.log("video_play_click", dt)
  trackByteEvent("video_play_click", dt);
  // call DLS
  // dt.content_type = thisInstance?.isSeries ? "series" : mediaData?.programType || mediaData?.videoType || null;
  // if content_type is episode, pass it as series
  // if (dt.content_type == "episode") { dt.content_type = "series" }
  // dt.content_type = mediaData?.programType
  //   ? mediaData?.programType
  //   : thisInstance?.isSeries
  //   ? "series"
  //   : mediaData?.programType || mediaData?.videoType || null;
  // if (carouselData) {
  //   if (carouselData.type == "cw") {
  //     if ((dt.content_type = "episode")) {
  //       dt.content_type = "series";
  //     }
  //   }
  // }
  // dt.channels_type = mediaData?.addonContent || null;
  triggerDLSEvent(await formatDLSData("video_play_click", dt));
}

export async function sendTrueViewImpressionForBytePlus({
  carouselId,
  carouselTitle,
  carouselOrderId,
  carouselContents,
  carouselData,
  userData,
  currentScreen,
  previousScreen,
  recVariant
}) {
  if (!userData) {
    const sdk = await getSdk();
    userData = await sdk.userManager.get();
  }
  var dt = {
    current_screen: currentScreen || sessionStorage.getItem("currentScreen") || null,
    previous_screen: previousScreen || sessionStorage.getItem("prevScreen") || null,
    carousel_id: carouselId || carouselData?.id || sessionStorage.getItem("refCarId") || null,
    carousel_name: carouselTitle || carouselData?.title || sessionStorage.getItem("refCarouselName") || null,
    carousel_order_id:
      carouselOrderId == 0
        ? 0
        : carouselOrderId || carouselData?.layoutOrder || sessionStorage.getItem("refCarouselOrderId") || null,
    rec_variant:
      carouselData?.contentRules?.type || recVariant || sessionStorage.getItem("refCarouselRecVariant") || null,
    contents: carouselContents || carouselData?.titles || null,
    language: localStorage.getItem("locale"),
    date_time: new Date().toISOString().substring(0, 19) + "Z",
    user_status: getAppState().userLogged || userData?.logged_in ? "login" : "log out",
    user_type: userData?.settings?.accountStatus || "Visitor",
    os_type: config.get().sdk.clientType,
    os_version: await extractOSVersion(),
    device_type: config.get().sdk.deviceType,
    device_model: await getDeviceInfo(),
    location_country: getAppState()?.country?.toUpperCase(),
    starz_uid: userData?.globalUserId || userData?.user?.globalUserId || null,
    guid: userData?.globalUserId || userData?.user?.globalUserId || null,
    entitlements: getAddonsListWithBase(),
    mop_detail: null,
    profile_type: getAppState()?.currentProfileType || userData?.profileType,
    // logged_in: getAppState().userLogged || userData?.logged_in ? "yes" : "no",
    // hash_uid: null,
    platform: "vidaa" || config.get().sdk.platFormName,
    a_profile_id: (await currentProfile()) || ""
  };
  if (dt.contents && dt.contents?.length) {
    dt.contents = await extractTitleIdFromContents(dt.contents);
    if (sessionStorage.getItem("currentlyPlayingisSeries")) {
      if (sessionStorage.getItem("currentlyPlayingisSeries") == "yes") {
        if (sessionStorage.getItem("currentlyPlayingid")) {
          let mId = sessionStorage.getItem("currentlyPlayingid");
          dt.contents_parent = [];
          for (let i = 0; i < dt.contents.length; i++) {
            dt.contents_parent.push(mId);
          }
        }
      }
    } else {
      dt.contents_parent = [];
      let contents = carouselContents || carouselData?.titles;
      for (let i = 0; i < contents.length; i++) {
        dt.contents_parent.push(contents[i]?.seriesId || contents[i]?.id);
      }
    }
  }
  // console.log("trueview_impression", dt)
  if (dt.contents && dt.contents.length > 0) {
    dt.contents = dt.contents.join(",");
  }
  if (dt.contents_parent && dt.contents_parent.length > 0) {
    dt.contents_parent = dt.contents_parent.join(",");
  }
  trackByteEvent("trueview_impression", dt);
  // call DLS
  // dt.guid = userData?.globalUserId || userData?.user?.globalUserId || null
  triggerDLSEvent(await formatDLSData("trueview_impression", dt));
}

export async function sendStayEventForBytePlus({
  titleId,
  seriesId,
  subType,
  userData,
  currentScreen,
  previousScreen,
  mediaData,
  playerCurrentTime,
  recVariant
}) {
  if (!userData) {
    const sdk = await getSdk();
    userData = await sdk.userManager.get();
  }
  var dt = {
    guid: userData?.globalUserId || userData?.user?.globalUserId || null,
    title_id: titleId || null,
    series_id: seriesId || sessionStorage.getItem("currentlyPlayingid"),
    current_screen: currentScreen || sessionStorage.getItem("currScreen2") || null,
    previous_screen: previousScreen || sessionStorage.getItem("prevScreen2") || null,
    device_type: config.get().sdk.deviceType,
    rec_variant: recVariant || sessionStorage.getItem("refCarouselRecVariant") || null,
    location_country: getAppState()?.country?.toUpperCase(),
    subscription_type: subType || null,
    current_season: null,
    episode_number: null,
    is_live: mediaData?.isLive || false,
    platform: "vidaa",
    stay_duration: calculateStayDuration(
      mediaData,
      mediaData?.isLive || false,
      mediaData.playbackTime,
      playerCurrentTime
    )
  };
  if (dt.series_id == "undefined" || dt.series_id == "null" || dt.series_id == undefined || dt.series_id == null) {
    dt.series_id = dt.title_id;
  }
  if (mediaData?.videoType != "movie" && mediaData?.videoType != "trailer") {
    dt.current_season = mediaData?.tvSeasonNumber || null;
    dt.episode_number = mediaData?.tvSeasonEpisodeNumber || null;
  }
  // console.log("stay", dt)
  trackByteEvent("stay", {
    ...dt,
    content_type: mediaData.contentTypeYoubora,
    asset_ownership: mediaData.contentOwnership || null
  });
  // call DLS
  triggerDLSEvent(await formatDLSData("stay", dt));
}
function calculateStayDuration(mediaData, isLive, videoStartTime, videoCurrentTime) {
  let startTime;
  let currTime = parseInt(videoCurrentTime);
  let stay_duration;
  if (isLive) {
    startTime = getAppState()?.playbackStartTime || 0;
    if (startTime === 0) {
      stay_duration = 0;
    } else {
      let playbackStoppedTime = new Date().getTime();
      stay_duration = playbackStoppedTime - startTime;
      getAppState().playbackStartTime = 0;
    }
  } else {
    startTime = videoStartTime || 0;
    if (startTime > currTime) {
      stay_duration = currTime * 1000;
    } else {
      stay_duration = (currTime - startTime) * 1000;
    }
  }
  return stay_duration;
}

function extractTitleIdFromContents(contents) {
  let extractedTitleIds = [];
  contents.forEach(content => {
    extractedTitleIds.push(content.id);
  });
  return extractedTitleIds;
}

/**
 * Sends a tracking event for Byte+.
 * @param {String} action
 * @param {Object} params
 * @public
 */
export function trackByteEvent(action, params) {
  // add 1 to params.carousel_order_id and title_order_id if they exist
  if (params.carousel_order_id != null && params.carousel_order_id != undefined && params.carousel_order_id >= 0) {
    params.carousel_order_id = parseInt(params.carousel_order_id) + 1;
  }
  if (params.title_order_id != null && params.title_order_id != undefined && params.title_order_id >= 0) {
    params.title_order_id = parseInt(params.title_order_id) + 1;
  }
  // if current or prev path is null in string, it will replace with null
  if (params.current_screen == "null") {
    params.current_screen = null;
  }
  if (params.previous_screen == "null") {
    params.previous_screen = null;
  }
  // if referring carousel id is coming(in case of direct playback from a carousel), set it, else clear it.
  if (params.referring_carousel_id) {
    sessionStorage.setItem("refCarouselId", params.referring_carousel_id);
  } else {
    sessionStorage.removeItem("refCarouselId");
  }
  // if rec_variant is null, remove it before sending
  if (!params.rec_variant) {
    delete params.rec_variant;
  }
  // using ReactGA package to send GA events
  ReactGA.event(action, params);
}

export function formatPathNames(path) {
  switch (path) {
    case "/series":
      return "tvshows_home_page";
    case "/movies":
      return "movies_home_page";
    case "/home":
      return "home_page";
    case "/search":
      return "search_page";
    case "/premium":
      return "starzplay_home_page";
    case "/sports":
      return "sports_home_page";
    case "/freemium":
      return "freetv_home_page";
    case "/live":
      return "livetv_page";
    case "/store":
      return "store_home_page";
    case "/brands":
      return "subscription_selection_page";
    case "/arabic":
      return "arabic_home_page";
    case "/kids":
      return "kids_home_page";
    case "/mylibrary":
      return "mylist_page";
    case "/settings":
      return "settings_page";
    case "/player":
      return "player_page";
    case "/brands1":
      return "subscription_selection_page";
    case "/admn":
      return "admn_home_page";
    default:
      // if /series/{some series id}, /movies/{some id} - details_page_{Title ID}
      if (path?.includes("/series/") || path?.includes("/movies/")) {
        let id = path?.split("/")[2];
        return `details_page_${id}`;
      } else if (path?.includes("/explore/brands/")) {
        let brand = path?.split("/")[3];
        return `explore_page_${brand}`;
      } else if (path?.includes("/explore/")) {
        let genre = path?.split("/")[2];
        return `explore_page_${genre}`;
      } else if (path?.includes("/brands/")) {
        let brand = path?.split("/")[2];
        return `${brand}_home_page`;
      } else if (path?.includes("/admn/")) {
        let id = path?.split("/")[2];
        return `${id}_home_page`;
      }
      return null;
  }
}

export async function getYouboraParamsForBytePlus({ userData, currentScreen, previousScreen, carouselId, titleId }) {
  if (!userData) {
    const sdk = await getSdk();
    userData = await sdk.userManager.get();
  }
  var dt = {
    rec_variant: sessionStorage.getItem("refCarouselRecVariant") || null,
    current_screen: currentScreen || sessionStorage.getItem("currScreen2") || sessionStorage.getItem("currentScreen"),
    previous_screen: previousScreen || sessionStorage.getItem("prevScreen2") || sessionStorage.getItem("prevScreen"),
    referring_carousel_id:
      carouselId || sessionStorage.getItem("refCarouselId") || sessionStorage.getItem("refCarId") || null,
    title_id: titleId || null,
    guid: userData?.globalUserId || userData?.user?.globalUserId || null,
    profileType: getAppState()?.currentProfileType || userData?.profileType,
    platform: "vidaa"
  };
  if (dt.current_screen == "null" || dt.current_screen == "undefined" || dt.current_screen == "/") {
    dt.current_screen = null;
  }
  if (dt.previous_screen == "null" || dt.previous_screen == "undefined" || dt.previous_screen == "/") {
    dt.previous_screen = null;
  }
  if (dt.referring_carousel_id == "null" || dt.referring_carousel_id == "undefined") {
    dt.referring_carousel_id = null;
  }
  if (!dt.rec_variant) {
    delete dt.rec_variant;
  }
  // console.log("youbora_params", dt)
  return dt;
}

async function getDeviceInfo() {
  try {
    const sdk = await getSdk();
    const model = await sdk.systemManager.device.getRealModel();
    if (model) {
      return model;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}

export async function extractOSVersion(userAgent) {
  try {
    // sampleRegex = "Mozilla/5.0 (X11; Linux armv7l) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.182 Odin/88.4324.2.10 Safari/537.36 Model/Hisense-MT9602 VIDAA/6.0(Hisense;SmartTV;55A53FXVT;MTK9602/V0000.06.30T.N0921;UHD;55A5FX;)"
    const userAgent = navigator?.userAgent;
    // extract VIDAA/version
    const match = userAgent.match(/VIDAA\/(\d+\.\d+)/);
    const match2 = userAgent.match(/VIDAA\/(\d+)/);
    if (match) {
      return match[1];
    } else if (match2) {
      return match2[1];
    } else if (userAgent.match(/MT5658/) || userAgent.match(/MT5659/) || userAgent.match(/MSD6586/)) {
      return "2.5";
    } else {
      return "2.5";
      // return userAgent;
    }
  } catch (e) {
    return null;
  }
}

export async function extractHisenseVersion() {
  const userAgent = navigator.userAgent;
  const match = userAgent.match(/VIDAA\/(\d+(\.\d+)?)/i);
  if (match) {
    return `Vidaa ${match[1]}`;
  }
  return "Vidaa";
}

async function returnLoggedInValue() {
  const sdk = await getSdk();
  const userData = await sdk.userManager.get();
  return getAppState().userLogged || userData?.logged_in ? "yes" : "no";
}

async function formatDLSData(eventName, dt) {
  switch (eventName) {
    case "carousel_click":
      return {
        event_name: "carousel_click",
        guid: dt?.guid || null,
        rec_variant: dt?.rec_variant || null,
        title_name: dt?.title_name || null,
        title_order_id: dt?.title_order_id || null,
        carousel_id: dt?.carousel_id || null,
        carousel_name: dt?.carousel_name || null,
        carousel_order_id: dt?.carousel_order_id || null,
        current_screen: dt?.current_screen || null,
        previous_screen: dt?.previous_screen || null,
        parent_slug: dt?.parent_slug || null,
        profile_type: dt?.profile_type || null,
        location_country: dt?.location_country || null,
        logged_in: await returnLoggedInValue(),
        title_id: dt?.title_id || null,
        language: dt?.language || null,
        device_type: dt?.device_type || null,
        user_type: dt?.user_type || null,
        content_type: dt?.content_type || null,
        series_id: dt?.series_id,
        program_category: dt.program_category,
        ...(await getStaticParamsForDLS(dt))
      };
    case "trueview_impression":
      return {
        event_name: "trueview_impression",
        guid: dt.guid,
        rec_variant: dt.rec_variant,
        carousel_id: dt.carousel_id,
        carousel_name: dt.carousel_name,
        carousel_order_id: dt.carousel_order_id,
        current_screen: dt.current_screen,
        previous_screen: dt.previous_screen,
        contents: dt.contents,
        contents_parent: dt.contents_parent,
        profile_type: dt.profile_type,
        location_country: dt.location_country,
        logged_in: await returnLoggedInValue(),
        language: dt.language,
        device_type: dt.device_type,
        user_type: dt.user_type,
        ...(await getStaticParamsForDLS(dt))
      };
    case "search_run":
      return {
        event_name: "search_run",
        guid: dt.guid,
        current_screen: dt.current_screen,
        previous_screen: dt.previous_screen,
        search_term: dt.search_term,
        profile_type: dt.profile_type,
        page_type: dt.page_type,
        location_country: dt.location_country,
        logged_in: await returnLoggedInValue(),
        language: dt.language,
        device_type: dt.device_type,
        user_type: dt.user_type,
        ...(await getStaticParamsForDLS(dt))
      };
    case "video_play_click":
      return {
        event_name: "video_play_click",
        guid: dt.guid,
        rec_variant: dt.rec_variant,
        title_name: dt.title_name,
        title_order_id: dt.title_order_id,
        carousel_id: dt.referring_carousel_id,
        carousel_name: dt.referring_carousel_name,
        carousel_order_id: dt.carousel_order_id,
        current_screen: dt.current_screen,
        previous_screen: dt.previous_screen,
        location_country: dt.location_country,
        language: dt.language,
        device_type: dt.device_type,
        channels_type: dt.channels_type, //
        user_type: dt.user_type,
        content_type: dt.content_type,
        parent_slug: dt.parent_slug,
        profile_type: dt.profile_type,
        age_rating: dt.age_rating,
        logged_in: await returnLoggedInValue(),
        title_id: dt.title_id,
        current_url: dt.current_url || sessionStorage.getItem("currScreen2"),
        series: dt.series,
        series_id: dt?.series_id,
        current_season: dt.current_season,
        episode_number: dt.episode_number,
        program_category: dt.program_category,
        ...(await getStaticParamsForDLS(dt))
      };
    case "stay":
      return {
        ...dt,
        event_name: "stay",
        ...(await getStaticParamsForDLS(dt))
      };
    default:
      return {};
  }
}

async function triggerDLSEvent(req) {
  // if rec_variant is null, remove it before sending
  if (!req.rec_variant) {
    delete req.rec_variant;
  }
  const sdk = await getSdk();
  sdk.analyticsManager.trackDLSEvent(config.get().dlsCallUrl, req);
}

export async function getStaticParamsForDLS(dlsData, specificKey = null) {
  var browserInfo = await getBrowserNameAndVersion();
  let obj = {
    platform: "vidaa",
    language: localStorage.getItem("locale"),
    app_version: packageJson.version,
    device_model: await getDeviceInfo(),
    os_type: config.get().sdk.clientType,
    os_version: await extractOSVersion(),
    device_vendor: await getDeviceVendorInfo(),
    browser: browserInfo?.name || null,
    browser_version: browserInfo?.version || null
  };
  if (!specificKey) {
    return obj;
  } else {
    return obj[specificKey];
  }
}

export async function getParamsForPredictCall() {
  var browserInfo = await getBrowserNameAndVersion();
  let obj = {
    platformByteplus: "vidaa",
    language: localStorage.getItem("locale"),
    appVersion: packageJson.version,
    deviceModel: await getDeviceInfo(),
    osType: config.get().sdk.clientType,
    osVersion: await extractOSVersion(),
    deviceVendor: await getDeviceVendorInfo(),
    browser: browserInfo?.name || null,
    browserVersion: browserInfo?.version || null
  };
  return obj || {};
}
// deviceVendor : webOS.deviceInfo(function (device) { if(device.manufacturer){return device.manufacturer} else{return null} })

async function getBrowserNameAndVersion() {
  // Tizen: "Mozilla/5.0 (SMART-TV; LINUX; Tizen 6.5) AppleWebKit/537.36 (KHTML, like Gecko) 85.0.4183.93/6.5 TV Safari/537.36"
  // WebOS: "Mozilla/5.0 (Web0S; Linux/SmartTV) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/87.0.4280.88 Safari/537.36 WebAppManager"
  // hisense: "Mozilla/5.0 (X11; Linux armv7l) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/111.0.5563.146 Odin/111.5563.5.1 Safari/537.36 Model/VIDAA-MTK9603 VIDAA/7.0(Hisense;SmartTV;55A70LAVT;MTK9603/V0000.07.60V.O0203;UHD;55A7NA;)"
  var userAgent = navigator.userAgent;
  const regexPatterns = {
    tizen: /(\d+\.\d+\.\d+\.\d+)\/(\d+\.\d+)/,
    tizenOld: /Version\/(\d+\.\d+)/,
    tizenOldest: /SamsungBrowser\/(\d+\.\d+)/,
    webos: /Chrome\/(\d+\.\d+\.\d+\.\d+)/,
    hisense: /Chrome\/(\d+\.\d+\.\d+\.\d+)/
  };

  const tizenPattern = /Tizen/;

  if (tizenPattern.test(userAgent)) {
    const match =
      userAgent.match(regexPatterns.tizen) ||
      userAgent.match(regexPatterns.tizenOld) ||
      userAgent.match(regexPatterns.tizenOldest);

    if (match) {
      return { name: "Chromium", version: match[1] };
    } else {
      return null;
    }
  } else {
    const match = userAgent.match(regexPatterns.webos) || userAgent.match(regexPatterns.hisense);

    if (match) {
      return { name: "Chrome", version: match[1] };
    } else {
      return null;
    }
  }
}

async function getDeviceVendorInfo() {
  try {
    const sdk = await getSdk();
    const manufacturer = await sdk.systemManager.device.getManufacturer();
    if (manufacturer) {
      return manufacturer;
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
}

export function getContentTypeForAnalytics(mediaData) {
  if (!mediaData) return null;
  if (mediaData.destination && mediaData.destination.target) return mediaData.destination.target;
  if (Object.prototype.hasOwnProperty.call(mediaData, "contentType"))
    return mediaData.contentType == null ? "NULL" : mediaData.contentType;
  if (mediaData.programType) return mediaData.programType;
  if (mediaData.seriesId) return "series";
  return "movie";
}
